export const environment = {
    production: false,
    stage: 2,
    scope: "api://2307de68-4464-44b5-9354-63358d09c488/test",
    endpoint: "https://devtkebbxbackofficebackend.azurewebsites.net/",
    clientId: "b1faf53d-a37d-4117-ac50-88796a59f3e7",
    authority: "https://login.microsoftonline.com/devtkebbx.onmicrosoft.com"
};
